<template>
  <div v-if="showTab === 1">
    <md-card-content>
      <div class="simple-tab-group">
        <table class="flex-table mb10 td-text-align-right">
          <tr>
            <th>합계</th>
            <td>{{ totalSum != null ? formatter.getCurrency(totalSum.feeCnt) : 0 }} 건</td>
            <td>{{ totalSum != null ? formatter.getCurrency(totalSum.feeAmt) : 0 }} 원</td>
          </tr>
        </table>
        <md-table :value="totalData" class="paginated-table table-striped table-hover text-align-center h500">
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="납부구분">{{ item.feeGbNm }}</md-table-cell>
            <md-table-cell md-label="회비구분">{{ item.feeCdNm }}</md-table-cell>
            <md-table-cell md-label="납입건수" style="text-align: right;">{{ formatter.getCurrency(item.feeCnt) }} 건</md-table-cell>
            <md-table-cell md-label="납입금액" style="text-align: right;">{{ formatter.getCurrency(item.feeAmt) }} 원</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </md-card-content>
  </div>
</template>
<script>

import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";

import Swal from "sweetalert2";

export default {
  name: "PaymentListTotalComp",
  props: {
    showTab : {
      type : Number,
      default : 1
    }
  },
  components: {
  },

  created() {
    this.sendQuery();
  },

  computed: {
  },
  data() {
    return {
      formatter,
      totalSum: {
        feeCnt: 0,
        feeAmt: 0
      },
      totalData : []
    };
  },
  methods: {
    sendQuery (query) {
      let option = query ? query : {};
      kuaaApi.sendServer(
        URL_CONST.GET_FEE_LIST_TOTAL,
        option,
        "post",
        (response) => {
          this.totalSum = response.data.data.contents.feeTotalInfo1[0];
          this.totalData = response.data.data.contents.feeTotalInfo2;
        }
      );
    }
  }
};
</script>

<style lang="css" scoped>

</style>